import { React, useState } from 'react';
import CodeSnippet from "./CodeSnippet";
import { Button, Grid, ButtonGroup, Dialog, DialogTitle, List, ListItem, ListItemButton, ListItemText } from '@mui/material';

function DecomposeDialog({ subfuns, onClose, selectedValue, open }) {

  const handleClose = () => { onClose(selectedValue) };
  const handleListItemClick = (value) => { onClose(value) };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Select a subfunction</DialogTitle>
      <List>
        {subfuns.map(([name, prompt]) => (
          <ListItem disableGutters key={name}>
            <ListItemButton onClick={() => handleListItemClick(name)}>
              <ListItemText primary={name + (prompt ? `: ${prompt}` : '')} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}

function CodeArea({ anpl }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(anpl.entry);

  const handleClose = (name) => { setOpen(false); setName(name); };
  const func = anpl.funs[name];
  const subfuns = func.subfunctions.map((subname) => [subname, anpl.funs[subname].prompt]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ButtonGroup variant="outlined">
          <Button onClick={() => { setName(func.parent) }} disabled={!func.parent}>Back</Button>
          <Button onClick={() => { setOpen(true) }} disabled={func.subfunctions.length === 0}>Decompose</Button>
        </ButtonGroup>
        <DecomposeDialog subfuns={subfuns} onClose={handleClose} selectedValue={name} open={open} />
      </Grid>
      <Grid item xs={12}>
        <CodeSnippet code={func.code} />
      </Grid>
    </Grid>
  );
}

export default CodeArea;